export default "__VITE_ASSET__s7i1b5j___"